import { money, pct } from './format.js';

// Cost, trailing return and risk figures are computed across the positions the
// vendor can price. When something is unpriced they cover less than the stated
// total, and the reader has to be told by how much rather than left to assume
// the number covers everything they own. Prints: the client is entitled to the
// caveat that comes with the number.

export default function CoverageNote({ unpriced, figures = 'The figures above' }) {
  if (!unpriced) return null;

  const { pricedValue, totalValue, pricedSharePct, count } = unpriced;

  return (
    <p className="asmt-coverage">
      {figures} cover {money(pricedValue)} of your {money(totalValue)}
      {Number.isFinite(pricedSharePct) ? `, or ${pct(pricedSharePct, 0)} of the total` : ''}. The
      rest sits in {count === 1 ? 'a holding' : 'holdings'} with no market price, listed below,
      and {count === 1 ? 'it is' : 'they are'} not included in these figures.
    </p>
  );
}
